import React, { useState } from "react";
import { Button, Form, DatePicker, message, Spin } from "antd";
import { get } from "lodash";
import { disabledDate, disabledTime } from "../../utilities/template";
import { useDispatch } from "react-redux";
import { syncTemplate } from "../../redux/actions/templateActions";
import { SYNC_TEMPLATE_SUCCESS,SYNC_TEMPLATE_FAILED } from "../../constants/message";
import dayjs from "dayjs";

const ResyncTemplate = ({ template, toggle, refresh }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const onSyncTemplate = (payload) => {
    setLoading(true);
    dispatch(syncTemplate(payload))
      .then((result) => {
        message.success(SYNC_TEMPLATE_SUCCESS);
        toggle();
        refresh();
        setLoading(false);
      })
      .catch((err) => {
        message.error(SYNC_TEMPLATE_FAILED);
        setLoading(false);
      }) 
  };

  const onFinish = (values) => {
    const dateTimeObj = get(values, "date_time");
    const formattedDateTime = dateTimeObj.format("YYYY-MM-DD HH:mm:ss");
    const payload = {
      dateTime: formattedDateTime,
      uuid: get(template, "id"),
    };
    onSyncTemplate(payload);
  };
  return (
    <Spin spinning={loading}>
      <div className="w-full h-full flex flex-col py-10">
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          className="flex-grow overflow-y-auto px-4"
        >
          <Form.Item
            name="date_time"
            label="Event Resync Time"
            rules={[
              {
                required: true,
                message: "Please select Template Sync Time...!",
              },
            ]}
          >
            <DatePicker
              showTime={{ format: "HH:mm", minuteStep: 15, hourStep: 1 }}
              style={{ width: "100%" }}
              format="DD-MM-YYYY HH:mm"
          disabledDate={disabledDate}
              disabledTime={disabledTime}
              placeholder={"Select Date and Time"}
              showNow
            />
          </Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form>
      </div>
    </Spin>
  );
};

export default ResyncTemplate;
